/*
 * TIC social proof — keeps the follower count in sync with the main site.
 *
 * The number is rendered STATICALLY by the theme (hero badge, marquee,
 * founder stats, footer stats, about stats). That value is correct on its
 * own — no JS required, present in the HTML for SEO and social scrapers.
 *
 * This script layers a live refresh on top: it fetches the same feed the
 * main site uses, sums the FOLLOWER keys only, and rewrites any on-page
 * text that matches the current static value. If the fetch fails the
 * static value simply stays put — the storefront can never show a blank.
 *
 * IMPORTANT — the live refresh is inert until the main site sends CORS:
 *     Access-Control-Allow-Origin: https://shop.tahsininvestmentsco.com
 * on https://tahsininvestmentsco.com/data/social-stats.json
 * Once that header exists this starts working with no change here.
 *
 * Feed shape: { live: { key: { value } }, manual: { key: value } }
 * Precedence: live.<key>.value when present, else manual.<key>.
 */
(function () {
  if (window.__ticSocialProof) return;
  window.__ticSocialProof = true;

  var CONFIG = {
    endpoint: 'https://tahsininvestmentsco.com/data/social-stats.json',
    staticTotal: 705138,
    staticDisplay: '700K+',
    // Follower accounts ONLY. Deliberately excludes email_subscribers and
    // every *_views / podcast_* key — those are reach, not followers.
    followerKeys: [
      'tiktok_ahmedtahsinat',
      'telegram_news',
      'youtube_tictalks',
      'instagram_ahmedtrading',
      'instagram_tictalksofficial',
      'facebook'
    ],
    // Guard rails: ignore an implausible feed so a broken upstream can
    // never push a junk number onto the storefront.
    min: 400000,
    max: 3000000
  };

  function total(feed) {
    var live = (feed && feed.live) || {};
    var manual = (feed && feed.manual) || {};
    var sum = 0;
    for (var i = 0; i < CONFIG.followerKeys.length; i++) {
      var key = CONFIG.followerKeys[i];
      var v = null;
      if (live[key] && typeof live[key].value === 'number') {
        v = live[key].value;
      } else if (typeof manual[key] === 'number') {
        v = manual[key];
      }
      if (typeof v === 'number' && isFinite(v) && v > 0) sum += v;
    }
    return sum;
  }

  // Round DOWN to the nearest 10k so the badge never overclaims.
  function display(n) {
    return Math.floor(n / 10000) * 10 + 'K+';
  }

  function apply(text) {
    if (!text || text === CONFIG.staticDisplay || !document.body) return;
    var walker = document.createTreeWalker(document.body, NodeFilter.SHOW_TEXT, null);
    var node;
    while ((node = walker.nextNode())) {
      if (node.nodeValue && node.nodeValue.indexOf(CONFIG.staticDisplay) !== -1) {
        node.nodeValue = node.nodeValue.split(CONFIG.staticDisplay).join(text);
      }
    }
  }

  function run() {
    fetch(CONFIG.endpoint, { mode: 'cors', credentials: 'omit' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (feed) {
        if (!feed) return;
        var sum = total(feed);
        if (sum < CONFIG.min || sum > CONFIG.max) return;
        apply(display(sum));
      })
      .catch(function () { /* offline / CORS — static value stands */ });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', run);
  } else {
    run();
  }
})();
